import classNames from "classnames";
import { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import styles from "./AccountTabs.module.scss";

type AccountTabsProps<T> = {
  selectedTab: T;
  setSelectedTab: Dispatch<SetStateAction<T>>;
  tabs: T[];
};

export const AccountTabs = <T,>({
  selectedTab,
  setSelectedTab,
  tabs,
}: AccountTabsProps<T>) => {
  const intl = useIntl();

  const renderTab = (tab: T, index: number) => (
    <div
      className={classNames(styles.tab, {
        [styles.activeTab]: selectedTab === tab,
      })}
      onClick={() => setSelectedTab(tab)}
      key={index}
    >
      {intl.formatMessage({ id: tab as unknown as string })}
    </div>
  );

  return (
    <div className={styles.tabs}>
      {tabs.map((tab: T, index: number) => renderTab(tab, index))}
    </div>
  );
};
